import {InputSearchDebounceEvents} from '../m-input-search-debounce/m-input-search-debounce.controller';
import ControllerBase from './../../../../global/js/ControllerBase';

type ComponentRefs = {
    flyoutSearchCloseButton: 'flyoutSearchCloseButton',
};

export default class ControllerSearchFlyout extends ControllerBase<ComponentRefs> {
    private static componentRefs: ComponentRefs = {
        flyoutSearchCloseButton: 'flyoutSearchCloseButton',
    };
    private closeButton: HTMLButtonElement;

    constructor(element: HTMLElement) {
        super(element, [], Object.values(ControllerSearchFlyout.componentRefs));
        this.closeButton = this.$element?.querySelector(".m-search-flyout__close-button") as HTMLButtonElement;
        this.registerEvents();
    }

    closeDropdown = (): void => {
        this.$element.classList.remove('uk-open')
        this.dispatchCustomEvent(InputSearchDebounceEvents.RESET_SEARCH, null, false, true)
    }

    private registerEvents() {
        this.closeButton?.addEventListener('click', this.closeDropdown);
        this.$element?.addEventListener('click', (event) => {
            const elem = this.$element?.querySelector('#m-search-flyout-container');
            if (!elem) return;

            const outsideClick = typeof event.composedPath === 'function' && !event.composedPath().includes(elem);

            if (outsideClick) this.closeDropdown();
        })
    }
}
